<div class="py-24px px-48px max-mobile:p-6px">
	<img
		(click)="closeDialog()"
		class="ml-auto cursor-pointer"
		src="./assets/images/close-square.svg"
		alt=""
	/>
	<img class="m-auto mb-24px" [src]="data.image" alt="" />
	<h1 class="text-font-18 font-DIN-bold font-bold text-dark-grey text-center">
		{{
			data?.type == 'add'
				? ('WALLET.ADD_SUBTRACT_POPUP.ENTER_ADDED_AMOUNT' | translate)
				: ('WALLET.ADD_SUBTRACT_POPUP.ENTER_SUBTRACT_AMOUNT' | translate)
		}}
	</h1>
	<form [formGroup]="formData">
		<mat-form-field class="w-full" appearance="outline">
			<mat-label>
				{{ 'GENERAL_LABELS.AMOUNT' | translate }}
			</mat-label>
			<input
				matInput
				autofocus="false"
				(keydown)="($event.keyCode !== 69)"
				class="text-dark-grey"
				formControlName="amount"
				type="number"
			/>
			<span matSuffix class="mt-5 mx-3 text-dark-grey">
				/

				{{
					data?.currency == 224
						? ('CURRENCY.EGP' | translate)
						: ('CURRENCY.SAR' | translate)
				}}
			</span>
			<mat-error>
				<validation-message
					[controller]="getController('amount')"
					controller_name="GENERAL_LABELS.AMOUNT"
					pattern_Message="VALIDATION.DGITSS"
				>
				</validation-message>
			</mat-error>
		</mat-form-field>
		<mat-form-field class="w-full" appearance="outline">
			<mat-label> {{ 'GENERAL_LABELS.REASON' | translate }} </mat-label>
			<input
				matInput
				autofocus="false"
				class="text-dark-grey"
				formControlName="reason"
				type="text"
				maxlength="150"
			/>
			<mat-error>
				<validation-message
					[controller]="getController('reason')"
					controller_name="GENERAL_LABELS.REASON"
				>
				</validation-message>
			</mat-error>
		</mat-form-field>

		<div class="flex items-baseline">
			<mat-checkbox
				class="mb-24px mt-12px"
				formControlName="showReasonToClient"
			></mat-checkbox>
			<p class="text-dark-grey text-font-16 my-0 ltr:mx-[11px]">
				{{
					'WALLET.ADD_SUBTRACT_POPUP.SHOW_TO_THE_CLIENT_SP'
						| translate
							: {
									name: data.SP
										? ('GENERAL.SERVICE_PROVIDER' | translate)
										: ('GENERAL.NEW_CLIENT' | translate)
							  }
				}}
			</p>
		</div>
		<button
			mat-button
			(click)="confirm()"
			[disabled]="formData.invalid"
			class="w-full bg-gradient text-off-white text-font-14 rounded-6px mb-12px"
		>
			{{
				data?.type == 'add'
					? ('WALLET.ADD_SUBTRACT_POPUP.ADD_AMOUNT' | translate)
					: ('WALLET.ADD_SUBTRACT_POPUP.SUBTRACT_AMOUNT' | translate)
			}}
		</button>
		<button
			(click)="closeDialog()"
			class="w-full border-[1px] border-secondry-color-Gray text-dark-grey py-[10px] rounded-6px"
		>
			{{ 'ACTIONS.CANCEL' | translate }}
		</button>
	</form>
</div>
